import { KindeClient } from '../../services/KindeClient';
import { Storage } from '@kinde-oss/react-native-sdk-0-7x';
import { Telemetry } from 'app/services/telemetry/Telemetry';

export class AuthService {
  static async login(): Promise<void> {
    try {
      await KindeClient.login();
      const userDetails = await KindeClient.getUserDetails();
      Telemetry.setUser({
        id: userDetails.id || 'unknown',
        email: userDetails.email,
      });
    } catch (error) {
      Telemetry.error(error, { event: 'auth.login.fail', domain: 'auth' });
      throw error;
    }
  }

  static async logout(): Promise<void> {
    try {
      await KindeClient.logout();
    } catch (error) {
      Telemetry.error(error, { event: 'auth.logout.fail', domain: 'auth' });
      throw error;
    }
  }

  static async getToken(): Promise<string | null> {
    try {
      const accessToken = await Storage.getAccessToken();
      return accessToken || null;
    } catch (error) {
      Telemetry.error(error, { event: 'auth.token.get.fail', domain: 'auth' });
      throw error;
    }
  }

  static async isAuthenticated(): Promise<boolean> {
    try {
      return await KindeClient.isAuthenticated;
    } catch (error) {
      Telemetry.error(error, { event: 'auth.check.fail', domain: 'auth' });
      return false;
    }
  }

  static async refreshToken(): Promise<string | undefined> {
    try {
      const result = await KindeClient.forceTokenRefresh();
      if (result) {
        Telemetry.event('auth.token_refresh.success', { domain: 'auth' }, 'info');
        return result.access_token;
      }
      Telemetry.event('auth.token_refresh.fail', { domain: 'auth' }, 'warning');
      return undefined;
    } catch (error) {
      Telemetry.error(error, { event: 'auth.token_refresh.fail', domain: 'auth' });
      throw error;
    }
  }

  static async clearToken(): Promise<void> {
    try {
      await KindeClient.cleanUp();
    } catch (error) {
      Telemetry.error(error, { event: 'auth.token.clear.fail', domain: 'auth' });
    }
  }

  static async getUserDetails() {
    try {
      return await KindeClient.getUserDetails();
    } catch (error) {
      Telemetry.error(error, { event: 'auth.user_details.fetch.fail', domain: 'auth' });
      throw error;
    }
  }

  static async getUserPermissions() {
    try {
      return await KindeClient.getPermissions();
    } catch (error) {
      Telemetry.error(error, { event: 'auth.user_permissions.fetch.fail', domain: 'auth' });
      throw error;
    }
  }
}
